export default __webpack_public_path__ + "static/media/fan.a58484c7.svg";